import { ProjectEstimatePhaseStepDetailBase } from './base/project-estimate-phase-step-detail-base';

export class ProjectEstimatePhaseStepDetail extends ProjectEstimatePhaseStepDetailBase { }